import { EnvironmentProviders, makeEnvironmentProviders, InjectionToken } from "@angular/core";

export const APPINSIGHTS_CONNECTIONSTRING = new InjectionToken<string>('Connection String for Application Insights');

export function provideApplicationInsights(connectionString: string): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: APPINSIGHTS_CONNECTIONSTRING,
            useValue: connectionString
        }
    ]);
}